// Cards de KPIs do Contas a Pagar (Vencidos / Hoje / A vencer / Pagos / Total).
// Extraído de FinanceiroContasPagar.tsx em 2026-05-23 (frontend wave 3B).
import { Card, Row, Col, Typography } from 'antd';

const { Text } = Typography;

export interface KpisData {
  total_periodo: number; qtd_periodo: number;
  valor_pago: number; qtd_pago: number;
  valor_a_vencer: number; qtd_a_vencer: number;
  valor_vencem_hoje: number; qtd_vencem_hoje: number;
  valor_vencidas: number; qtd_vencidas: number;
}

export function KpisCP({ kpis }: { kpis: KpisData }) {
  const itens = [
    { label: 'Vencidos (R$)', valor: kpis.valor_vencidas, qtd: kpis.qtd_vencidas, cor: '#B91626' },
    { label: 'Vencem hoje (R$)', valor: kpis.valor_vencem_hoje, qtd: kpis.qtd_vencem_hoje, cor: '#E07A1F' },
    { label: 'A vencer (R$)', valor: kpis.valor_a_vencer, qtd: kpis.qtd_a_vencer, cor: '#0930D0' },
    { label: 'Pagos (R$)', valor: kpis.valor_pago, qtd: kpis.qtd_pago, cor: '#0a7f4a' },
    { label: 'Total do período (R$)', valor: kpis.total_periodo, qtd: kpis.qtd_periodo, cor: '#020D7F' },
  ];
  return (
    <Row gutter={0} style={{ marginBottom: 14 }}>
      {itens.map((k, i) => (
        <Col key={i} xs={12} md={5} flex="1">
          <Card size="small" bodyStyle={{ padding: 14 }} style={{
            borderRadius: i === 0 ? '6px 0 0 6px' : i === 4 ? '0 6px 6px 0' : 0,
            borderLeft: i > 0 ? 'none' : undefined,
          }}>
            <Text type="secondary" style={{ fontSize: 11 }}>{k.label}</Text>
            <div style={{ fontSize: 22, fontWeight: 700, color: k.qtd > 0 ? k.cor : '#bbb', lineHeight: 1.1, marginTop: 4 }}>
              {k.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <Text type="secondary" style={{ fontSize: 10 }}>
              {k.qtd} {k.qtd === 1 ? 'lançamento' : 'lançamentos'}
            </Text>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
